import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_communications/fax")({
  beforeLoad: ({ context }) => guardRoute(context.me, "fax"),
  component: Outlet,
});
